import { Injectable } from '@angular/core';
import { FavoritePlacesService } from './favorite-places.service';
import { FavoriteSpacesService } from './favorite-spaces.service';
import { FavoriteControlsService } from './favorite-controls.service';
import { FavoriteGraphsService } from './favorite-graphs.service';
import { Favorite, GenericFavoriteService } from '../models/favorite';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FavoriteService {
    public favoritePlaces$ = this.favoritePlacesService.favorites$;
    public favoriteSpaces$ = this.favoriteSpacesService.favorites$;
    public favoriteControls$ = this.favoriteControlsService.favorites$;
    public favoriteGraphs$ = this.favoriteGraphsService.favorites$;

    public get changeFavoriteObserver() {
        return this.changeFavoriteSubject.asObservable();
    }

    private changeFavoriteSubject = new Subject<boolean>();

    constructor(
        public favoritePlacesService: FavoritePlacesService,
        public favoriteSpacesService: FavoriteSpacesService,
        public favoriteControlsService: FavoriteControlsService,
        public favoriteGraphsService: FavoriteGraphsService
    ) {
    }

    public changeFavorite(isFavorite?: boolean) {
        this.changeFavoriteSubject.next(isFavorite);
    }

    public toggleFavorite<T, R extends Favorite>(favoriteService: GenericFavoriteService<T, R>, favorite: R) {
        favoriteService.toggleFavorite(favorite);
    }

    public isFavorite<T, R>(favoriteService: GenericFavoriteService<T, R>, favorite: R) {
        return favoriteService.isFavorite(favorite);
    }
}
